import React from 'react';
import { Download, Loader2, AlertTriangle, CheckCircle2 } from 'lucide-react';

// Persistent bottom CTA so mobile users don't have to scroll past six
// collapsed accordion sections to find Export. Shares the same
// useExportJob() instance as ExportControls (passed down from SpinEditor)
// so status/progress always stays in sync between the two.
export default function MobileExportBar({ exportJob }) {
  const { status, phaseLabel, pct, errorMsg, canExport, handleExport } = exportJob;

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm border-t border-neutral-200 px-4 py-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
      data-testid="mobile-sticky-export-bar"
    >
      {status === 'exporting' ? (
        <div className="space-y-1.5">
          <div className="flex items-center gap-2 text-sm text-neutral-700">
            <Loader2 className="w-4 h-4 animate-spin text-orange-600 flex-shrink-0" />
            <span className="truncate">{phaseLabel}</span>
            <span className="ml-auto text-xs text-neutral-400 font-mono flex-shrink-0">{Math.round(pct)}%</span>
          </div>
          <div className="h-1.5 rounded-full bg-neutral-100 overflow-hidden">
            <div className="h-full bg-orange-600 transition-all" style={{ width: `${pct}%` }} />
          </div>
        </div>
      ) : status === 'error' ? (
        <button
          type="button"
          onClick={handleExport}
          className="flex items-center justify-center gap-2 w-full h-12 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold"
          data-testid="mobile-export-retry-button"
        >
          <AlertTriangle className="w-4 h-4" /> {errorMsg || 'Export failed — Try again'}
        </button>
      ) : status === 'done' ? (
        <button
          type="button"
          onClick={handleExport}
          className="flex items-center justify-center gap-2 w-full h-12 rounded-lg bg-neutral-900 hover:bg-neutral-800 text-white text-sm font-semibold"
          data-testid="mobile-export-again-button"
        >
          <CheckCircle2 className="w-4 h-4" /> Export again
        </button>
      ) : (
        <button
          type="button"
          onClick={handleExport}
          disabled={!canExport}
          className="flex items-center justify-center gap-2 w-full h-12 rounded-lg bg-orange-600 hover:bg-orange-700 disabled:bg-neutral-200 disabled:text-neutral-400 disabled:cursor-not-allowed text-white text-sm font-semibold transition-colors"
          data-testid="mobile-export-video-button"
        >
          <Download className="w-4 h-4" /> {canExport ? 'Export video' : 'Finish uploads to export'}
        </button>
      )}
    </div>
  );
}
